// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-title[data-v-91344444] {\n  color: var(--main-dark-color);\n}\nhr[data-v-91344444] {\n  border-top: 1px solid var(--main-dark-color);\n}\n.parent-info-card[data-v-91344444] {\n  color: var(--text-light-color);\n  border-color: var(--main-dark-color);\n}\n.parent-info-card .card[data-v-91344444] {\n  border: 1px solid var(--text-light-color);\n  border-radius: 15px;\n}\ninput[data-v-91344444] {\n  border-color: var(--main-dark-color);\n}", ""]);
// Exports
module.exports = exports;
